// extracted by mini-css-extract-plugin
module.exports = {"AppFooter":"Footer_AppFooter__2cnlH"};